import {
  INPUT_MANAGEMENT_ALLOCATE_MODEL_LIST,
  INPUT_MANAGEMENT_ALLOCATE_SEARCH,
  INPUT_MANAGEMENT_ALLOCATE_PAGINATION,
  INPUT_MANAGEMENT_ALLOCATE_DROP_DOWN_SEARCH_TYPE,
} from "./actionType";


import moment from 'moment';

const initialState = {
  modelDeviceList: [],
  modelSearch: { UPLOAD_DATE: "", UPLOAD_TO_DATE: "", UPLOAD_START: "", UPLOAD_TO: "", UPLOADTYPE_NAME: null, STATUS_FLAG: 0 },
  dropDownSearchType: null,
  pagination: { sizePerPage: 100, page: 1 }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INPUT_MANAGEMENT_ALLOCATE_MODEL_LIST:
      return { ...state, modelDeviceList: action.payload };
    case INPUT_MANAGEMENT_ALLOCATE_SEARCH:
      return {
        ...state,
        modelSearch: action.payload,
      };
    case INPUT_MANAGEMENT_ALLOCATE_PAGINATION:
      return { ...state, pagination: { sizePerPage: action.payload.sizePerPage, page: action.payload.page } };
    case INPUT_MANAGEMENT_ALLOCATE_DROP_DOWN_SEARCH_TYPE:
      return {
        ...state,
        dropDownSearchType: action.payload,
      }
    default:
      return state;
  }
};
